<template>
    <section class="personalise-finance">
        <div class="configurator__container">
            <StepBar class="container hidden__xs" step-name="Your configuration" :step="7" :steps="7" />
            <div class="container hidden__sm hidden__md hidden__lg">
                <div class="configurator__success-container">
                    <p class="configurator__success-text">Thank you for your configuration</p>
                </div>
            </div>

            <div class="container">
                <div class="configurator__flex-container">
                    <div class="configurator__flex-left">
                        <h2 class="configurator-title hidden__xs">Thank you for your {{ model.model_title }} configuration</h2>

                        <p class="hidden__xs">Your build looks great! Please find a summary of your configuration below as well as options to take a test drive of a similar vehicle, discover finance options or share your configuration with friends and family.</p>
                        <p class="hidden__sm hidden__md hidden__lg">Your build looks great! Please find a summary of your configuration below:</p>

                        <ImageGallery :show-delivery="true" />
                    </div>

                    <div class="configurator__flex-right">
                        <Card :limitHeight="false" :title="model.model_title" :description="engineChoice" :price="totalVehiclePrice">
                            <div v-if="financeAvailable !== false">
                                <LoadingSpinner v-if="financeLoading"></LoadingSpinner>
                                <template v-else>
                                    <span class="configurator__price-per-month-label">Per month on:</span>

                                    <div class="configurator__finance-price-container">
                                        <p class="configurator__finance-label">{{ financeName }}*</p>
                                        <span @click="personaliseFinance" class="configurator__finance-price" v-html="formattedMonthlyPrice"></span>
                                    </div>
                                </template>
                            </div>

                            <a v-if="financeAvailable !== false" @click="personaliseFinance" class="btn btn--finance-inverted btn--full-width">Personalise finance</a>

                            <SaveConfiguration :button-style="true" class="margin-top-15 margin-bottom-15" :custom-event="{
                                category: 'Configurator Final Screen',
                                label: 'Save Configuration',
                                action: 'Clicked',
                            }" />

                            <table class="configurator__selections">
                                <tbody>
                                    <tr>
                                        <td class="configurator__selection-heading">Gearbox</td>
                                        <td class="configurator__selection-value">{{ gearboxChoice.replace("AUTO", "Automatic").replace("MANUAL", "Manual") }}</td>
                                    </tr>

                                    <tr>
                                        <td class="configurator__selection-heading">Fuel type</td>
                                        <td class="configurator__selection-value">{{ fuelTypeChoice.replace("Petrol/PlugIn Elec Hybrid", "Plug-in Hybrid") }}</td>
                                    </tr>

                                    <tr>
                                        <td class="configurator__selection-heading">Trim level</td>
                                        <td class="configurator__selection-value">{{ trimChoice }}</td>
                                    </tr>

                                    <tr>
                                        <td class="configurator__selection-heading">Interior</td>
                                        <td class="configurator__selection-value" v-if="selectedInteriorName != null">{{ selectedInteriorName }}</td>
                                        <td v-else>-</td>
                                    </tr>

                                    <tr>
                                        <td class="configurator__selection-heading">Colour</td>
                                        <td class="configurator__selection-value">{{ paint }}</td>
                                    </tr>

                                    <tr>
                                        <td colspan="2">
                                            <Navigation class="margin-top-15" :go-to-step="{ name: 'select-interior', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }" link-text="Edit my choices" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Card>

                        <a :href="testDriveUrl" class="btn btn--primary btn--full-width configurator__test-drive-btn" @click="testDrive">Book a test drive</a>

                    </div>
                </div>

                <Card :limitHeight="false" class="margin-top-45">
                    <h3 class="configurator__specification-title">Key Specification</h3>

                    <KeySpecs v-if="!loadingSpecs" :specs="specs" />
                    <LoadingSpinner v-else></LoadingSpinner>
                </Card>

                <div class="configurator__full-specification margin-top-45">
                    <h3 class="configurator__specification-title">Full vehicle specification</h3>
                    <span v-if="selectedNewVehicle">for {{ model.model_title }} {{ selectedNewVehicle.bodystyle }} {{ selectedNewVehicle.version }}</span>

                    <template v-if="!loadingFullSpec">
                        <div class="swiper" ref="buttons">
                            <div class="swiper-wrapper configurator__buttons-wrapper">
                                <div class="swiper-slide configurator__button" :class="{ 'configurator__button--active': activeCategory === 'General' }" @click="setActiveSpecs('General', techSpecs)">General</div>

                                <div
                                    class="swiper-slide configurator__button"
                                    v-for="(specs, category) in standardSpecs"
                                    :class="{ 'configurator__button--active': activeCategory === category }"
                                    @click="setActiveSpecs(category, specs)"
                                    :key="category"
                                >
                                    {{ category }}
                                </div>
                            </div>
                        </div>

                        <div v-if="activeCategory === 'General'">
                            <template v-for="(spec, category) in activeSpec">
                                <Accordion :key="'accordion-' + category" :specs="spec" :category="category" :firstElement="category === Object.keys(activeSpec)[0]" />
                            </template>
                        </div>

                        <div v-else>
                            <ul class="configurator__specs-grid" v-if="activeCategory !== 'Options'">
                                <li v-for="(spec, index) in activeSpec" :key="index">
                                    {{ spec }}
                                </li>
                            </ul>

                            <div v-else>
                                <template v-for="(spec, category) in activeSpec">
                                    <h3 :key="category" class="margin-top-15 configurator__spec-category">{{ category }}</h3>
                                    <ul :key="'grid-' + category" class="configurator__specs-grid">
                                        <li v-for="(name, index) in spec" :key="index" v-html="name"></li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </template>
                    <LoadingSpinner v-else></LoadingSpinner>
                </div>
            </div>

            <div ref="finance-calculator" class="margin-top-45 configurator__finance-calculator" v-if="financeAvailable !== false">
                <div class="container">
                    <FinanceCalculator />
                </div>
            </div>

            <div class="bg">
                <valuation-tool />
            </div>
        </div>

        <CMSOfferModal ref="offerModal" />

        <!-- <SaveConfigurationModal ref="saveConfigurationModal" /> -->
    </section>
</template>

<script>
import KeySpecs from "../components/KeySpecs.vue";
import Accordion from "../components/Accordion.vue";
import FinanceCalculator from "../components/FinanceCalculator.vue";
import SaveConfigurationModal from "../components/SaveConfigurationModal.vue";
import CMSOfferModal from "../components/CMSOfferModal.vue";
import Swiper from "swiper";
import { mapState } from "vuex";
import NumberFormat from '../../used-vue/api/NumberFormat';
import getFinanceNameFromKey from '../../used-vue/api/finance/GetFinanceNameFromKey';
import { customEvent } from '../../modules/tracking/AnalyticsEvents';
import ValuationTool from "../../valuation-tool/ValuationTool.vue";

export default {
    props: {
        brand: {
            type: String,
            required: true,
        },
        urlModel: {
            type: String,
            required: true,
        },
    },
    components: {
        KeySpecs,
        Accordion,
        FinanceCalculator,
        SaveConfigurationModal,
        CMSOfferModal,
        ValuationTool,
    },
    data() {
        return {
            loadingSpecs: true,
            specs: null,
            loadingFullSpec: true,
            standardSpecs: null,
            techSpecs: null,
            activeCategory: null,
            activeSpec: null,
            timeout: null,
            timeout2: null,
            modalLoaded: false,
        };
    },
    methods: {
        setFullSpecs: function (vehicleId) {
            axios.get(`/api/configurator/full-specs/${vehicleId}`)
                .then(response => {
                    this.standardSpecs = response.data.standardSpecs;
                    this.techSpecs = response.data.techSpecs;
                    this.setActiveSpecs("General", response.data.techSpecs);
                    this.loadingFullSpec = false;
                    this.$nextTick(() => {
                        new Swiper(this.$refs["buttons"], {
                            grabCursor: true,
                            slidesPerView: "auto",
                            spaceBetween: 10,
                            speed: 400,
                            direction: "horizontal",
                        });
                    });
                })
                .catch(error => {
                    console.error("Error loading full spec");
                    console.error(error);
                })
        },

        setActiveSpecs: function (category, specs) {
            this.activeCategory = category;
            this.activeSpec = specs;
        },

        scrollTo: function (refName) {
            let element = this.$refs[refName];
            element.scrollIntoView({ behavior: "smooth" });
        },

        // showModal: function () {
        //     this.$refs.saveConfigurationModal.openModal();
        // },

        // checkModal: function () {
        //     clearTimeout(this.timeout);

        //     this.timeout = setTimeout(() => {
        //         if (this.modalLoaded) return;
        //         this.showModal();
        //         this.unbindEvents();
        //         this.modalLoaded = true;
        //     }, 5000);
        // },

        // bindEvents: function () {
        //     document.addEventListener("scroll", this.checkModal);
        //     document.addEventListener("mousemove", this.checkModal);
        //     document.addEventListener("touchstart", this.checkModal);
        //     document.addEventListener("touchmove", this.checkModal);
        //     document.addEventListener("keydown", this.checkModal);
        // },

        // unbindEvents: function () {
        //     document.removeEventListener("scroll", this.checkModal);
        //     document.removeEventListener("mousemove", this.checkModal);
        //     document.removeEventListener("touchstart", this.checkModal);
        //     document.removeEventListener("touchmove", this.checkModal);
        //     document.removeEventListener("keydown", this.checkModal);
        //     clearTimeout(this.timeout);
        //     clearTimeout(this.timeout2);
        //     this.timeout = null;
        //     this.timeout2 = null;
        // },

        personaliseFinance() {
            customEvent('Configurator Final Screen', 'Personality Finance', 'Clicked');
            this.scrollTo('finance-calculator');
        },

        testDrive() {
            customEvent('Configurator Final Screen', 'Book A Test Drive', 'Clicked');
        }
    },
    mounted() {
        document.title = `Congratulations On Your ${this.model.model_title} Configuration `;

        axios.get(`/api/configurator/key-specs/${this.vehicleId}`)
            .then(response => {
                this.specs = response.data.data;
                this.loadingSpecs = false;
            }).catch(error => {
                this.loadingSpecs = false;
                console.error("Error loading specs");
                console.error(error);
            });

        this.setFullSpecs(this.vehicleId);

        // this.$store.dispatch("getInteriors").then((response) => {
        //     response.map((interior) => {
        //         if (Number(this.interiorChoice) === Number(interior.id)) {
        //             this.selectedInteriorName = interior.name.length > 25 ? interior.name.split("-")[0] : interior.name;
        //             this.$store.commit("setSelectedInteriorPrice", interior.price);
        //             this.$store.commit('updateFinanceRequests');
        //         }
        //     });
        // });

        // this.bindEvents();
        // this.checkModal();
        // this.timeout2 = setTimeout(() => {
        //     if (this.modalLoaded) return;
        //     this.showModal();
        //     this.unbindEvents();
        //     this.modalLoaded = true;
        // }, 30000);
    },
    computed: {
        ...mapState([
            "manufacturer",
            "model",
            "engineChoice",
            "gearboxChoice",
            "fuelTypeChoice",
            "trimChoice",
            "interiorChoice",
            "vehicleId",
            "configuratorId",
            "paintOptions",
            "paintChoice",
            "selectedVehiclePrice",
            "selectedPaintPrice",
            "selectedInteriorName",
            "selectedInteriorPrice",
            "selectedNewVehicle",
        ]),
        ...mapState('Finance', [
            'financeLoading',
            'financeType',
            'monthlyPayment',
            'numberOfPayments',
            'financeAvailable'
        ]),

        financeName() {
            if (this.financeType == null) {
                return null;
            }
            return getFinanceNameFromKey({
                brand: this.selectedNewVehicle.brand,
                manufacturer: this.selectedNewVehicle.manufacturer,
            }, this.financeType, false);
        },

        formattedMonthlyPrice() {
            if (this.monthlyPayment == null) {
                return null;
            }
            return '£' + NumberFormat(this.monthlyPayment);
        },

        paint() {
            const paintOptionsLength = this.paintOptions.length;

            if (this.paintChoice == null) {
                return this.paintOptions[0].name;
            }

            for (let index = 0; index < paintOptionsLength; index++) {
                const paintOption = this.paintOptions[index];
                if (paintOption.id === this.paintChoice) {
                    return paintOption.name;
                }
            }

            return this.paintOptions[0].name;
        },

        totalVehiclePrice() {
            return Number(this.selectedVehiclePrice) + Number(this.selectedPaintPrice) + Number(this.selectedInteriorPrice);
        },

        testDriveUrl() {
            return '/' + this.model.brand + '/book-a-test-drive/' + this.model.url_model;
        }
    },
};
</script>

<style lang="scss" scoped>
.margin-top-15 {
    margin-top: 15px !important;
}
.margin-bottom-15 {
    margin-bottom: 15px !important;
}

.margin-top-45 {
    margin-top: 45px !important;
}

.full-w {
    width: 100%;
}

.configurator__price-per-month-label {
    font-size: 13px;
    color: #4a4a4a;
}

.configurator__finance-price-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.configurator__finance-label {
    margin: 10px 0;
}

.configurator__finance-price {
    font-weight: 700;
    color: #0093d6;
    font-size: 16px;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.configurator__buttons-wrapper {
    margin-top: 25px;

    .configurator__button {
        height: 45px;
        width: 175px;
        border: solid 2px #0093d6;
        border-radius: 10px;
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        font-weight: 700;
        color: #0093d6;

        &--active {
            background-color: #0093d6;
            color: #fff;
        }
    }
}

.configurator__spec-category {
    font-weight: 700;
    font-size: 16px;
    color: #243782;
}

.configurator__finance-calculator {
    background-color: rgba(94, 181, 101, 0.1);
    padding: 45px 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/pages/PersonaliseFinance.vue